import React, {useEffect} from "react";
import {SocketContext} from "./socketContext";
import createApiSocket from '../../api/socket'

const socket = createApiSocket();

const SocketProvider = (props) => {

    const onSocketMessage = (m) => {
    }

    useEffect(() => {
        socket.addEventListener('message', onSocketMessage);

        return () => {
            socket.removeEventListener('message', onSocketMessage);
        }
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {props.children}
        </SocketContext.Provider>
    )
};

export default SocketProvider;